import React, { Component, useCallback } from 'react';
import { withProps } from 'recompose';
import { useDispatch } from 'react-redux';
import Notification from './Notification';
import { hideNotificationAction } from './store/actions';
import { useTranslations } from 'js/hooks/i18n';
import style from './index.scss';

export class Buttons extends Component {
    static defaultProps = {
        onClose: () => {},
        onAccept: () => {},
        onDecline: () => {},
        acceptTitle: '',
        declineTitle: ''
    };

    handleEvent = (event, eventHandler) => {
        const { id, onClose, hideNotification } = this.props;

        eventHandler(event);
        onClose();
        hideNotification(id);
    };

    render() {
        const { onAccept, onDecline, acceptTitle, declineTitle, t } = this.props;

        return (
            <div className={style.buttons}>
                <div className={style.decline}
                    onClick={e => this.handleEvent(e, onDecline)}>
                    {declineTitle || t('common.notification.button.decline')}
                </div>
                <div className={style.accept}
                    onClick={e => this.handleEvent(e, onAccept)}>
                    {acceptTitle || t('common.notification.button.accept')}
                </div>
            </div>
        );
    }
}

export const ButtonsConnected = withProps(() => {
    const dispatch = useDispatch();

    return {
        t: useTranslations(),
        hideNotification: useCallback(id => dispatch(hideNotificationAction(id)), [dispatch])
    };
})(Buttons);

export default ({
    id,
    onAccept,
    onDecline,
    acceptTitle,
    declineTitle,
    onClose,
    enableAutoHide = false,
    onClick = onAccept,
    ...props
}) =>
    <Notification id={id}
        onClose={onClose}
        enableAutoHide={enableAutoHide}
        onClick={onClick}
        {...props}>
        <ButtonsConnected id={id}
            onClose={onClose}
            onAccept={onAccept}
            onDecline={onDecline}
            acceptTitle={acceptTitle}
            declineTitle={declineTitle} />
    </Notification>;
